import luCountTo from "./vue-countTo.vue";

luCountTo.install = function(Vue) {
  Vue.component(luCountTo.name, luCountTo);
};

export default luCountTo;
